import Vue from "vue";
import Vuetify from "vuetify/lib";
import { en, ru, fr, ja } from "vuetify/lib/locale";

Vue.use(Vuetify);

// CLCUP brand theme (dark by default; user choice is kept in localStorage)
export default new Vuetify({
  lang: { locales: { en, ru, fr, ja }, current: "ru" },
  theme: {
    dark: true,
    options: { customProperties: true },
    themes: {
      light: {
        primary: "#ff5a1f",
        secondary: "#334155",
        accent: "#0891b2",
        error: "#e11d48",
        background: "#eef1f6",
        footer: "#0f172a"
      },
      dark: {
        primary: "#ff6a2b",
        secondary: "#1b2436",
        accent: "#22d3ee",
        error: "#fb7185",
        background: "#0b0f17",
        footer: "#090d14"
      }
    }
  }
});
